<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Product Image</label>
            <input type="checkbox" v-model="fields.productImage.show" />
          </div>
          <div class="group-item">
            <v-select
              v-model="fields.productImage.position"
              label="Position"
              :items="positionOptions"
              item-text="text"
              item-value="value"
            />
            <UploadImage
              @callback="handleUploadProductImage"
              :image="{ imageSrc: fields.productImage.src }"
              :height="`200`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveProductImage"
            />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Info</label>
          <div class="group-item">
            <div>
              <p class="mb-2 font-weight-bold">Title</p>
              <ckeditor :editor="editor" :config="editorConfig" v-model="fields.info.title" />
            </div>
            <div class="mt-4">
              <p class="mb-2 font-weight-bold">Policy</p>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model="fields.info.policy.moneyBack" label="Money Back" hide-details />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="fields.info.policy.fastShipping" label="Fast Shipping" hide-details />
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="fields.info.policy.support" label="Support" hide-details />
                </v-col>
              </v-row>
            </div>
            <div class="mt-4">
              <p class="mb-2 font-weight-bold">Rating Image</p>
              <UploadImage
                @callback="handleUploadRatingImage"
                :image="{ imageSrc: fields.info.ratingImage }"
                :height="`100`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveRatingImage"
              />
            </div>
            <div class="mt-4">
              <p class="mb-2 font-weight-bold">Timer</p>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field v-model="fields.info.timer.text" label="Text" hide-details />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model.number="fields.info.timer.time"
                    label="Time"
                    hide-details
                    type="number"
                    min="0"
                    suffix="minutes"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'fastvaluedeal-countdown-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    ButtonPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        {
          text: 'Left',
          value: 'left',
        },
        {
          text: 'Right',
          value: 'right',
        },
      ],
      fields: {
        title: 'FastValueDeal Countdown Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        button: {
          show: true,
          backgroundColor: '#606F99',
          color: '#FFFFFF',
          radius: 8,
          text: 'GET 80% DISCOUNT',
          link: '#',
          iconPrefix: {
            show: false,
            src: '',
          },
          iconSuffix: {
            show: false,
            src: 'false',
          },
          subBtn: {
            show: false,
            text: '',
          },
        },
        productImage: {
          show: true,
          src: '',
          position: 'left',
        },
        info: {
          title: '',
          policy: {
            moneyBack: '',
            fastShipping: '',
            support: '',
          },
          ratingImage: '',
          timer: {
            text: 'Ending Soon:',
            time: 10, // minutes
          },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
      };
      const updateHtml = updateHtmlFromData.sectionFastvaluedealCountdown(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadProductImage(obj) {
      this.fields.productImage.src = (obj && obj.imageSrc) || '';
    },
    handleRemoveProductImage() {
      this.fields.productImage.src = '';
    },
    handleUploadRatingImage(obj) {
      this.fields.info.ratingImage = (obj && obj.imageSrc) || '';
    },
    handleRemoveRatingImage() {
      this.fields.info.ratingImage = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
